import React from "react";
import { Col, Button, Row } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";

const PageTitle = ({
  pageTitle,
  pageSubtitle,
  setShowForm,
  actionName,
  setEditing,
}) => {
  return (
    <Row>
      <Col className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3 className="page-title">{pageTitle}</h3>
          <p className="page-subtitle">{pageSubtitle}</p>
        </div>
        {actionName && (
          <Button
            onClick={() => {
              setShowForm(true);
              setEditing({});
            }}
          >
            <FaPlus /> {actionName}
          </Button>
        )}
      </Col>
    </Row>
  );
};

export default PageTitle;
